import React from 'react';
import { Typography } from "@material-tailwind/react";
import video from '../assets/smog.mp4'; // Adjust the path to your video file

const Product = () => {
  return (
<div className="flex flex-col justify-center items-center pt-20">
  <div className="mb-16 text-center">
    <p className="text-[#00df9a] text-center font-bold mt-20">Pakistan's First</p>
    <h1 className="text-3xl font-bold text-center mt-3 mb-10">Smog Eating Billboard</h1>
  </div>
  
  <div className="relative w-full max-w-4xl flex justify-center items-center">
    <video className="w-full h-auto" controls>
      <source src={video} type="video/mp4" />
      Your browser does not support the video tag.
    </video>
  </div>
</div>

  );
}

export default Product;
